<template>
  <div>
    <div v-html="content"/>
  </div>
</template>

<script>
import axios from 'axios'
import MarkdownIt from 'markdown-it';
import MIAttrs from 'markdown-it-attrs';
import MIReplaceLink from 'markdown-it-replace-link';
import MISup from 'markdown-it-sup';
import MISub from 'markdown-it-sub';
import MIKatex from 'markdown-it-katex';

import hljs from 'highlight.js/lib/highlight';
import cpp from 'highlight.js/lib/languages/cpp';
import shell from 'highlight.js/lib/languages/shell';
hljs.registerLanguage('cpp', cpp);
hljs.registerLanguage('shell', shell);

export default {
  name: 'Markdown',
  data() {
    return {
      content: null
    };
  },
  watch: {
    $route(to, from) {
      if (to.path != from.path) {
        this.render_markdown();
      }
      if (to.hash == "#top") {
        this.$router.history.replace(to.path);
        window.scrollTo(0, 0);
      }
    }
  },
  mounted() {
    this.render_markdown();
  },
  methods: {
    render_markdown() {
      let md = new MarkdownIt({
        html: true,
        highlight: (str) => {
          try {
            return hljs.highlightAuto(str).value;
          } catch (__) {
            return '';
          }
        }
      });
      md.use(MIAttrs);
      md.use(MIReplaceLink);
      md.use(MISup);
      md.use(MISub);
      md.use(MIKatex);

      this.content = null;
      axios.get("markdown/" + this.$route.params.folder + "/" + this.$route.params.name + "/"+ this.$route.params.name + ".md")
        .then(response => {

          var text = response.data;

          // find includes and load them
          const re = /{{(.*?)}}/g;
          const matches = Array.from(text.matchAll(re));
          const urls = matches.map((match) => "markdown/" + this.$route.params.folder + "/" + this.$route.params.name + "/" + match[1]);

          Promise.all(urls.map((el) => axios.get(el)))
            .then((results) => {

              // work backwards so indexes don't get messed up
              for (let i = matches.length - 1; i >= 0; i--) {
                let match = matches[i];
                let s = match[0];
                let url = urls[i];
                let idx = url.lastIndexOf("/");
                let rel = url;
                if (idx !== -1) {
                  rel = url.slice(0, idx);
                }

                // set up to alter links relative to the folder we obtained
                // this include from
                md.set({
                  replaceLink: (link) => {
                    if (!(link.includes("://"))) {
                      if (link.startsWith("/")) {
                        // other pages on the site
                        return this.$router.resolve(link).href;
                      }
                      else {
                        // resources in the folder we got this markdown from
                        return rel + "/" + link;
                      }
                    }
                    // full URLs
                    return link;
                  }
                })

                // render and inject the html of the included markdown into
                // the main page markdown
                let fragment = md.render(results[i].data);
                text = text.slice(0, match.index) + "\n" + fragment + "\n" + text.slice(match.index + s.length);
              }

              // link setup for the main page
              md.set({
                replaceLink: (link) => {
                  if (!(link.includes("://"))) {
                    if (link.startsWith("/")) {
                      // other pages on the site
                      return this.$router.resolve(link).href;
                    }
                    else {
                      // resources in this folder
                      return "markdown/" + this.$route.params.folder + "/" + this.$route.params.name + "/" + link;
                    }
                  }
                  // full URLs
                  return link;
                }
              });

              // finally, render this page and feed into Vue
              this.content = md.render(text);
              console.log(this);
            })
            .catch(error => {
              this.content = "<h2>" + error + "</h2>";
            });
          });
      }
  }
}
</script>
